
  var _styles = {
  "recommend5-price-container": {
    "borderRadius": "0.24rem",
    "backgroundColor": "rgb(255,255,255)",
    "width": "4.49333rem",
    "height": "1.53333rem",
    "position": "relative",
    "display": "flex",
    "flexDirection": "column",
    "justifyContent": "space-between",
    "padding": "0.24rem"
  },
  "recommend5-top-content": {
    "display": "flex",
    "flexDirection": "row",
    "alignItems": "center",
    "justifyContent": "space-between",
    "width": "4.01333rem"
  },
  "recommend5-city-name": {
    "color": "rgb(34,34,34)",
    "fontSize": "0.37333rem",
    "fontWeight": "500",
    "fontFamily": "PingFang SC"
  },
  "recommend5-bottom-content": {
    "display": "flex",
    "flexDirection": "row",
    "alignItems": "center",
    "justifyContent": "space-between",
    "height": "0.37333rem",
    "position": "absolute",
    "bottom": "0.24rem",
    "left": "0.24rem",
    "width": "4.01333rem"
  },
  "recommend5-font-grey": {
    "color": "rgb(102,102,102)",
    "fontSize": "0.32rem",
    "fontWeight": "400",
    "fontFamily": "PingFang SC"
  },
  "recommend5-discout-container": {
    "height": "0.37333rem",
    "borderRadius": "0.08rem",
    "borderWidth": "0.01333rem",
    "borderStyle": "solid",
    "borderColor": "rgb(255,75,16)",
    "display": "flex",
    "alignItems": "center",
    "justifyContent": "center"
  },
  "recommend5-discout-text": {
    "fontSize": "0.26667rem",
    "fontWeight": "500",
    "color": "rgb(255,75,16)",
    "fontFamily": "PingFang SC",
    "marginLeft": "0.04rem",
    "marginRight": "0.04rem"
  },
  "recommend5-price": {
    "display": "flex",
    "flexDirection": "row",
    "alignItems": "baseline",
    "fontSize": "0.48rem",
    "fontWeight": "500",
    "color": "rgb(255,102,0)",
    "fontFamily": "PingFang SC"
  },
  "recommend5-small-price": {
    "fontSize": "0.37333rem"
  },
  "recommend5-city": {
    "display": "flex",
    "flexDirection": "row",
    "alignItems": "center",
    "fontSize": "0.37333rem",
    "fontWeight": "500",
    "whiteSpace": "nowrap"
  }
};



  module.exports = _styles;
  